<template>
  <div>
    <div class="m-header">
      {{ title }}
    </div>
    <div class="m-body">
      <div
        class="mb-4 confirm-message"
        v-text="message"
      />
      <div class="d-flex justify-content-end">
        <button
          :disabled="isProcessing"
          class="btn btn-1 mr-3"
          @click="$emit('close')"
        >
          {{ cancelText }}
        </button>
        <button
          :disabled="isProcessing"
          :class="danger ? 'btn-danger-solid' : 'btn-2'"
          class="btn"
          @click="confirm"
        >
          <i
            v-if="isProcessing"
            class="fa fa-spinner fa-spin"
          />
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      title: { type: String, default: 'Confirmação' },
      message: { type: String, required: true },
      confirmText: { type: String, default: 'Confirmar' },
      cancelText: { type: String, default: 'Cancelar' },
      danger: { type: Boolean, default: false },
      onConfirm: { type: Function, required: true }
    },
    data: () => ({
      isProcessing: false
    }),
    methods: {
      async confirm () {
        this.isProcessing = true
        try {
          await this.onConfirm()
          this.$emit('close')
        } finally {
          this.isProcessing = false
        }
      }
    }
  }
</script>

<style scoped>
  .confirm-message {
    white-space: pre-line;
  }
</style>
